<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        General Reminders
      </h5>
      <b-col v-if="objectAndPropsNotEmpty(reminders)">
        <b-alert v-if="arrayNotEmpty(reminders.townQuarantineTypes)" variant="danger" show>
          Your proposed activity is in an area where the following forestry
          {{pluralizeMultiple('quarantine', reminders.townQuarantineTypes)}}
          {{pluralizeMultiple('is', reminders.townQuarantineTypes)}} in place:
          <a
            v-for="quarantineType in reminders.townQuarantineTypes"
            :key="quarantineType.name"
            class="d-block"
            :href="quarantineType.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{quarantineType.name}}
          </a>
        </b-alert>
        <b-alert v-if="arrayNotEmpty(reminders.townEmergencyOrderTypes)" variant="danger" show>
          Your proposed activity is in an area where the following
          {{pluralizeMultiple('emergency order', reminders.townEmergencyOrderTypes)}}
          {{pluralizeMultiple('is', reminders.townEmergencyOrderTypes)}} in place:
          <a
            v-for="emergencyOrderType in reminders.townEmergencyOrderTypes"
            :key="emergencyOrderType.name"
            class="d-block"
            :href="emergencyOrderType.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{emergencyOrderType.name}}
          </a>
        </b-alert>
        <b-alert v-if="reminders.awwTown" variant="danger" show>
          If your proposed activity is within the 1-mile Allagash Wilderness Waterway (AWW) buffer,
          contact the AWW at (207) 941-4014 or (207) 287-3821 prior to beginning the operation.
        </b-alert>
        <b-alert v-if="reminders.canadaLynxTown" variant="danger" show>
          Your activity occurs in a town that contains
          <a :href="links.canadaLynx" target="_blank" rel="noopener noreferrer">
            critical Canada Lynx habitat</a>.
        </b-alert>
        <b-alert v-if="reminders.atlanticSalmonTown" variant="danger" show>
          Your activity occurs in a town that abuts rivers and streams with
          <a :href="links.atlanticSalmon" target="_blank" rel="noopener noreferrer">
            important Atlantic salmon habitat</a>.
        </b-alert>
      </b-col>
      <b-col v-else>
        There are no important reminders.
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Utilities from '@/mixins/Utilities';

export default {
  name: 'GeneralReminders',
  mixins: [Utilities],
  computed: {
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState('Notification', {
      reminders: state => state.importantReminders.generalReminders,
    }),
  },
};
</script>
